import { render, staticRenderFns } from "./postThreads.vue?vue&type=template&id=62a9f010"
import script from "./postThreads.vue?vue&type=script&lang=js"
export * from "./postThreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a9f010')) {
      api.createRecord('62a9f010', component.options)
    } else {
      api.reload('62a9f010', component.options)
    }
    module.hot.accept("./postThreads.vue?vue&type=template&id=62a9f010", function () {
      api.rerender('62a9f010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postThreads.vue"
export default component.exports